module.exports = __webpack_public_path__ + "img/show-list.dfba3ce6.svg";